import React from 'react';

export interface TabOption {
  value: string;
  label: string;
  count?: number;
}

interface TabsProps {
  options: TabOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ options, value, onChange, className = '' }) => {
  return (
    <div className={`tabs-container ${className}`}>
      <div className="tabs">
        {options.map((option) => (
          <button
            key={option.value}
            className={`tab ${value === option.value ? 'active' : ''}`}
            onClick={() => onChange(option.value)}
            type="button"
          >
            {option.label}
            {option.count !== undefined && option.count > 0 && (
              <span className="tab-count">{option.count}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
